import React, { useState } from "react";
import { LocationOn, Phone, Email, Schedule } from "@mui/icons-material";
import { toast } from "react-toastify";
import ScrollAnimation from "../components/ScrollAnimation";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    website: "", // Honeypot - bot tuzağı (görünmez alan)
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading) return; // Çift gönderim engelleme

    setIsLoading(true);

    try {
      // Backend API'ye form verisini gönder
      const response = await fetch(
        "https://rpmkompresor.com/be/api/contact/send",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            company: formData.company,
            message: formData.message,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        toast.success(result.message || "✅ Mesajınız başarıyla gönderildi!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Formu temizle
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          message: "",
        });
      } else {
        throw new Error(result.message || "Bir hata oluştu");
      }
    } catch (error) {
      console.error("Mail gönderme hatası:", error);

      toast.error(
        error.message ||
          "❌ Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="container">
          <h1 className="page-title">İletişim</h1>
          <p className="page-subtitle">
            Kompresör ihtiyaçlarınız için bizimle iletişime geçin. Uzman
            ekibimiz size en uygun çözümü sunacaktır.
          </p>
        </div>
      </div>

      <div className="contact-content">
        <div className="container">
          <div className="contact-info-section">
            <div className="contact-info">
              <ScrollAnimation direction="left" delay={0}>
                <div className="contact-item">
                  <div className="contact-icon location-icon">
                    <LocationOn sx={{ fontSize: 28, color: "#f59e0b" }} />
                  </div>
                  <div className="contact-details">
                    <h3>Adresimiz</h3>
                    <p>
                      ERC iş merkezi, İvedik OSB, 1443. Sk. No:20/B
                      <br />
                      06480 Yenimahalle/Ankara
                    </p>
                  </div>
                </div>
              </ScrollAnimation>

              <ScrollAnimation direction="left" delay={100}>
                <div className="contact-item">
                  <div className="contact-icon phone-icon">
                    <Phone sx={{ fontSize: 28, color: "#3b82f6" }} />
                  </div>
                  <div className="contact-details">
                    <h3>Telefon</h3>
                    <p>
                      <a href="tel:+905342137564" className="phone-link">
                        +90 0534 213 75 64
                      </a>
                      <br />
                    </p>
                  </div>
                </div>
              </ScrollAnimation>

              <ScrollAnimation direction="left" delay={200}>
                <div className="contact-item">
                  <div className="contact-icon email-icon">
                    <Email sx={{ fontSize: 28, color: "#8b5cf6" }} />
                  </div>
                  <div className="contact-details">
                    <h3>E-posta</h3>
                    <p>
                      info@rpmendustri.com
                      <br />
                      satis@rpmendustri.com
                    </p>
                  </div>
                </div>
              </ScrollAnimation>

              <ScrollAnimation direction="left" delay={300}>
                <div className="contact-item">
                  <div className="contact-icon schedule-icon">
                    <Schedule sx={{ fontSize: 28, color: "#10b981" }} />
                  </div>
                  <div className="contact-details">
                    <h3>Çalışma Saatleri</h3>
                    <p>
                      Pazartesi - Cumartesi: 08:00 - 17:30
                      <br />
                      7/24 Destek
                    </p>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>

          <div className="contact-form-section">
            <ScrollAnimation direction="right" delay={0}>
              <div className="contact-form-container">
                <h2 className="form-title">Bize Mesaj Gönderin</h2>
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Ad Soyad *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">E-posta *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="phone">Telefon</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="company">Şirket</label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Mesajınız *</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  {/* Honeypot - Bot tuzağı (görünmez alan) */}
                  <input
                    type="text"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    style={{ position: "absolute", left: "-9999px" }}
                    tabIndex="-1"
                    autoComplete="off"
                    aria-hidden="true"
                  />

                  <button
                    type="submit"
                    className="btn btn-primary btn-full"
                    disabled={isLoading}
                    style={{
                      opacity: isLoading ? 0.7 : 1,
                      cursor: isLoading ? "not-allowed" : "pointer",
                    }}
                  >
                    {isLoading ? "📤 Gönderiliyor..." : "Mesaj Gönder"}
                  </button>
                </form>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
